// Modules
import React from "react";
import PropTypes from "prop-types";

const YouTube = (props) => {
	const {
		clssName,
		color,
	} = props;

	return (
		<svg
			width="46"
			height="33"
			viewBox="0 0 46 33"
			xmlns="http://www.w3.org/2000/svg"
			className={clssName}
		>
			<g clipPath="url(#clip0)">
				<path
					d="M22.9979 33C22.9943 33 22.9898 33 22.9853 33C21.5972 32.9902 9.32667 32.8794 5.85011 31.9464C3.42048 31.2976 1.50307 29.3959 0.847726 26.983C-0.0623718 23.5925 -0.00385919 17.0652 0.00244218 16.5442C-0.00385919 16.025 -0.0623718 9.44415 0.845025 6.02592C0.845925 6.02234 0.846825 6.01966 0.847726 6.01609C1.49497 3.63092 3.45649 1.67024 5.84381 1.02055C5.85011 1.01877 5.85641 1.01698 5.86181 1.01609C9.29966 0.118856 21.5954 0.00983021 22.9862 0H23.0114C24.4031 0.00983021 36.7061 0.120643 40.1512 1.05541C42.5745 1.70241 44.491 3.60143 45.1472 6.01072C46.0906 9.43164 46.0033 16.0268 45.9943 16.5836C46.0006 17.1323 46.0564 23.6005 45.1517 27.008C45.1508 27.0116 45.1499 27.0143 45.149 27.0179C44.4937 29.4298 42.5763 31.3324 40.144 31.9812C40.1404 31.9821 40.1377 31.983 40.1341 31.9839C36.6971 32.8802 24.4022 32.9902 23.0114 33C23.0069 33 23.0024 33 22.9979 33ZM4.31888 6.94102C3.52041 9.958 3.59512 16.4558 3.59602 16.521V16.5684C3.57172 18.37 3.65634 23.5889 4.31888 26.0599C4.64025 27.2431 5.58635 28.1805 6.78541 28.5013C9.35097 29.1903 19.3449 29.4066 22.997 29.4325C26.659 29.4075 36.6683 29.1966 39.2141 28.5353C40.4095 28.2145 41.352 27.2797 41.6761 26.0947C42.3395 23.5871 42.4233 18.3941 42.3989 16.6032C42.3989 16.5844 42.3989 16.5657 42.3989 16.5469C42.4323 14.723 42.3674 9.44415 41.6788 6.95264C41.6779 6.94996 41.677 6.94817 41.677 6.94549C41.3538 5.75693 40.4077 4.81948 39.2087 4.49866C36.6683 3.80876 26.6581 3.59339 22.997 3.56747C19.3377 3.59249 9.33837 3.8034 6.78451 4.46381C5.60886 4.7882 4.64115 5.75871 4.31888 6.94102ZM43.4135 26.5541H43.4144H43.4135ZM18.4177 23.7239V9.27525L30.9962 16.4996L18.4177 23.7239Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath>
					<rect
						width="46"
						height="33"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

YouTube.propTypes = {
	clssName: PropTypes.string,
	color: PropTypes.string,
};

YouTube.defaultProps = {
	clssName: "",
	color: "#EEDFD2",
};

export default YouTube;
